import { render } from "./TheHeader.vue?vue&type=template&id=34641e0d&scoped=true&lang=pug&bindings={}"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=34641e0d&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-34641e0d"

export default script